/**
 * Service for Heracles Test A/B funcs..
 */


(function () {
  'use strict';

  angular.module('itxApp.common').service('ItxHeraclesSvc', ItxHeraclesSvc);

  ItxHeraclesSvc.$inject = ['DUTTI_CONS', 'CommonServices'];


  function ItxHeraclesSvc(DUTTI_CONS, CommonServices) {


    function _verifyAttachmentCategory(category) {
      var id = category.id;
      if (category.attachments.length > 0) {
        var heraclesAttachment = _.filter(category.attachments, function (attachment) {
          if (!attachment || !attachment.name) {
            return false;
          }
          return attachment.name.indexOf('HERACLES') > -1;
        });
        if (heraclesAttachment.length > 0) {
          var managerHeracles = { totalItems: 0, type: null };
          _.forEach(sessionStorage, function (x, i) { // Cambiar por for.
            var key = sessionStorage.key(i);
            if (key.indexOf('heracles') > -1) {
              managerHeracles.totalItems++;
              if (managerHeracles.type === null) {
                var itemHeracles = sessionStorage.getItem(key);
                managerHeracles.type = JSON.parse(itemHeracles).value;
              }
            }
          });

          var categoryId = heraclesAttachment[0].path.split('_')[1];

          let sessionHeracles = undefined;
          const heraclesKey = `heracles_${id}`;
          const cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
          const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);

          if(isCookieGroupAllowed){
              sessionHeracles = inditex.getSessionStorage(heraclesKey);
          }

          if (sessionHeracles) {
            const sessionHeraclesObj = JSON.parse(sessionHeracles);
            const value = sessionHeraclesObj.value;
            if (value === 'heracles') {
              const categoryHeracles = sessionHeraclesObj.heraclesId
              return categoryHeracles;
            } else {
              return false;
            }
          } else {
            if (managerHeracles.totalItems > 0) {
              if (managerHeracles.type === 'heracles') {
                if(isCookieGroupAllowed){
                  inditex.setSessionStorage(heraclesKey, JSON.stringify({ value: 'heracles', heraclesId: categoryId, categoryId: id }));
                }
                return categoryId;
              } else {
                if(isCookieGroupAllowed){
                  inditex.setSessionStorage(heraclesKey, JSON.stringify({ value: 'manual' }));
                }
                return false;
              }
            } else {
              if (Math.floor(Math.random() * 2) === 1) {
                if(isCookieGroupAllowed){
                  inditex.setSessionStorage(heraclesKey, JSON.stringify({ value: 'heracles', heraclesId: categoryId, categoryId: id }));
                }
                return categoryId;
              } else {
                if(isCookieGroupAllowed){
                  inditex.setSessionStorage(heraclesKey, JSON.stringify({ value: 'manual' }));
                }
                return false;
              }
            }

          }
        } else {
          return false
        }

      } else {
        return false;
      }
    }




    return {
      // Devolver funciones.
      verifyAttachmentCategory: _verifyAttachmentCategory
    };
  }




})();

